import { TCheckoutTypeState } from '../../store/slices/checkoutType.slice';

export const checkIsButtonDesabledOnStepAddress = (
    checkoutTypeState: TCheckoutTypeState,
): boolean => {
    const { checkoutType, step } = checkoutTypeState;
    const result = checkoutType === 'TYPE_CHECKOUT_STEP_BY_STEP' && step === 'STEP_ADDRESS';
    return result;
};
